import { origin } from './constant';

const MiscURI = {
  sdkVersionURI: `${origin}/misc/sdk/:key`,
};

export default MiscURI;

